export const downloadImageAsBase64 = async (url: string) =>
  new Promise<string>((resolve, reject) => {
    if (url.startsWith('data:')) {
      resolve(url);
      return;
    }

    const imageExtensions = [
      '.png',
      '.jpg',
      '.jpeg',
      '.gif',
      '.bmp',
      '.webp',
      '.svg'
    ];
    if (!imageExtensions.some(ext => url.includes(ext))) {
      resolve(url);
      return;
    }

    // console.log('downloading image', url);

    window
      .proxyFetch(url, {
        cache: 'force-cache'
      })
      .then(response => response.blob())
      .then(blob => {
        const reader = new FileReader();
        reader.onload = function() {
          resolve(this.result as string);
        };
        reader.onerror = () =>
          reject(new Error(`Failed to read blob for image: ${url}`));
        reader.readAsDataURL(blob);
      })
      .catch(err => {
        console.log('Could not download image', url, err);
        reject(err);
      });
  });
